<template>
  <AhOvDocuments
    title="Ladda upp filer för andrahandshyresgästen"
    :computed-documents-groups="inviteeComputedDocumentsGroups"
    :application-is-editable="applicationIsEditable"
    :rejected-categories="rejectedCategories"
    :application="application"
    :descriptions="{}"
    :labels="labels"
    :documents-per-category="documentsPerCategory"
    :document-info-texts="{}"
    :category-types="['secondary_tenant']"
    @goToNextCategory="goToNextCategory($router)"
    ><CollapseCard
      slot="collapse-card"
      is-primary
      initially-open
      class="mb-4"
      :closed-identifier="dynamicClosedIdentifier"
    >
      <h3 slot="title-text">Läs detta först</h3>
      <template slot="body-text">
        <div class="info-text-container"></div>
        <p>Tänk på att:</p>
        <ul>
          <li>Alla fyra hörn skall vara synliga</li>
          <li>Kvaliteten skall vara god även vid utskrift</li>
          <li>
            Filerna måste vara i något av följande format, .pdf / .jpg / .png
          </li>
        </ul>
        <p>
          <strong>Tips:</strong> För att fota dokument på bästa sätt
          rekommenderar vi att du använder dig av en app som scannar av
          dokument. Exempel på appar som fungerar bra till både iOS och Android
          är Adobe Scan och Genius Scan, båda helt gratis att använda.
        </p>
        <ul>
          <li>
            <a
              href="https://apps.apple.com/se/app/adobe-scan-document-scanner/id1199564834"
              target="_blank"
              >Länk till Adobe Scan iOS</a
            >
          </li>
          <li>
            <a
              href=" https://apps.apple.com/se/app/genius-scan-pdf-scanner/id377672876"
              target="_blank"
              >Länk till Genius Scan iOS</a
            >
          </li>
          <li>
            <a
              href=" https://play.google.com/store/apps/details?id=com.adobe.scan.android&hl=sv"
              target="_blank"
              >Länk till Scan Android</a
            >
          </li>
          <li>
            <a
              href=" https://play.google.com/store/apps/details?id=com.thegrizzlylabs.geniusscan.free&hl=sv"
              target="_blank"
              >Länk till Genius Scan Android</a
            >
          </li>
        </ul>
        <p>
          Behöver du hjälp? Hör av dig till oss på
          <a
            :href="`mailto:${getSupportAddress}?subject=Andra%20Hand`"
            target="_blank"
          >
            {{ getSupportAddress }}</a
          >
        </p>
      </template>
    </CollapseCard></AhOvDocuments
  >
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import AhOvDocuments from '@/components/AhOvDocuments.vue';
import CollapseCard from '@/components/CollapseCard.vue';

export default {
  components: {
    AhOvDocuments,
    CollapseCard
  },
  computed: {
    ...mapState({
      application: state => state.subletApplication.application
    }),
    ...mapGetters({
      secondaryTenantDisplayName:
        'subletApplication/secondaryTenantDisplayName',
      applicationIsEditable: 'subletApplication/applicationIsEditable',
      rejectedCategories: 'subletApplication/rejectedCategories',
      requiredInviteeDocuments: 'subletApplication/requiredInviteeDocuments',
      noneInviteeRequiredDocuments:
        'subletApplication/noneInviteeRequiredDocuments',
      getSupportAddress: 'app/getSupportAddress'
    }),
    reason() {
      return this.application?.reason;
    },
    reasonType() {
      return this.reason?.type;
    },
    inviteeComputedDocumentsGroups() {
      return this.application?.inviteeComputedDocumentsGroups || {};
    },
    documentsPerCategory() {
      return [
        ...this.requiredInviteeDocuments,
        ...this.noneInviteeRequiredDocuments
      ];
    },
    labels() {
      return {
        studieintyg: 'Här laddar du upp studieintyg',
        övrigt: 'Här laddar du upp övriga dokument'
      };
    },
    dynamicClosedIdentifier() {
      switch (this.reasonType) {
        case 'sambo':
          return 'cohabitant_card_closed';
        case 'arbete':
          return 'work_info_card_closed';
        case 'studie':
          return 'study_info_card_closed';
        case 'utlandsvistelse':
          return 'abroad_info_card_closed';
        case 'other':
          return 'other_info_card_closed';
        default:
          return 'default_info_card_closed';
      }
    }
  },
  methods: {
    ...mapActions({
      goToNextCategory: 'subletApplication/goToNextCategory'
    })
  }
};
</script>

<style scoped>
.info-text-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.q-and-a-container {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 1rem;
}
</style>
